// Taboola defaults for cricket, all editions.
//
// Notes:
// 1. '*_webview' only used in webview mode.
// 2. 'publisher_webview' gets 'ios' or 'android' appended to it on those platforms.
// 3. 'mode_webview' gets '-iOS' or '-Android' appended to it on those platforms.
// 4. 'commentary' => 'gamepackage'
// 5. 'coverage' => 'gamepackage'
// 6. 'game' => 'gamepackage'
// 7. 'hawkeye' => 'gamepackage'
// 8. 'match' => 'gamepackage'
// 9. 'preview' => 'article' (only available via gamepackage in Reduxion)
// 10. 'report' => 'article' (only available via gamepackage in Reduxion)
// 11. 'scorecard' => 'gamepackage'
// 12. 'statistics' => 'gamepackage'
// 13. 'video' => 'gamepackage'

export default {
  'publisher_webview': 'espnappsnetwork-espncricinfo',
  'commentary': {
    'type': 'category',
    'mode': 'thumbnails-3x2-a',
    'mode_webview': 'thumbnails-2x2-Cricinfo',
    'container': 'taboola-below-section-front-thumbnails',
    'container_webview': 'taboola-below-section-front-thumbnails',
    'target_type': 'mix'
  },
  'coverage': {
    'type': 'category',
    'mode': 'thumbnails-3x2-a',
    'mode_webview': 'thumbnails-2x2-Cricinfo',
    'container': 'taboola-below-section-front-thumbnails',
    'container_webview': 'taboola-below-section-front-thumbnails',
    'target_type': 'mix'
  },
  'game': {
    'type': 'category',
    'mode': 'thumbnails-3x2-a',
    'mode_webview': 'thumbnails-2x2-Cricinfo',
    'container': 'taboola-below-section-front-thumbnails',
    'container_webview': 'taboola-below-section-front-thumbnails',
    'target_type': 'mix'
  },
  'hawkeye': {
    'type': 'category',
    'mode': 'thumbnails-3x2-a',
    'mode_webview': 'thumbnails-2x2-Cricinfo',
    'container': 'taboola-below-section-front-thumbnails',
    'container_webview': 'taboola-below-section-front-thumbnails',
    'target_type': 'mix'
  },
  'match': {
    'type': 'category',
    'mode': 'thumbnails-3x2-a',
    'mode_webview': 'thumbnails-2x2-Cricinfo',
    'container': 'taboola-below-section-front-thumbnails',
    'container_webview': 'taboola-below-section-front-thumbnails',
    'target_type': 'mix'
  },
  'preview': {
    'type': 'article',
    'mode': 'thumbnails-3x2-a',
    'mode_webview': 'thumbnails-2x2-Cricinfo',
    'container': 'taboola-below-article-thumbnails',
    'container_webview': 'taboola-below-article-thumbnails',
    'target_type': 'mix'
  },
  'report': {
    'type': 'article',
    'mode': 'thumbnails-3x2-a',
    'mode_webview': 'thumbnails-2x2-Cricinfo',
    'container': 'taboola-below-article-thumbnails',
    'container_webview': 'taboola-below-article-thumbnails',
    'target_type': 'mix'
  },
  'scorecard': {
    'type': 'category',
    'mode': 'thumbnails-3x2-a',
    'mode_webview': 'thumbnails-2x2-Cricinfo',
    'container': 'taboola-below-section-front-thumbnails',
    'container_webview': 'taboola-below-section-front-thumbnails',
    'target_type': 'mix'
  },
  'statistics': {
    'type': 'category',
    'mode': 'thumbnails-3x2-a',
    'mode_webview': 'thumbnails-2x2-Cricinfo',
    'container': 'taboola-below-section-front-thumbnails',
    'container_webview': 'taboola-below-section-front-thumbnails',
    'target_type': 'mix'
  },
  'video': {
    'type': 'category',
    'mode': 'thumbnails-3x2-a',
    'mode_webview': 'thumbnails-2x2-Cricinfo',
    'container': 'taboola-below-section-front-thumbnails',
    'container_webview': 'taboola-below-section-front-thumbnails',
    'target_type': 'mix'
  }
}



// WEBPACK FOOTER //
// ../app/lib/utils/editions/config/cricinfo/taboola.js